// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"1931":"1f540771d1e736d484d1","2991":"1cbfa8b0d34d5d2c1b29","3244":"04426ec365767387c05a","3911":"1a274c2b5302006c45da","5348":"511b473b8c1e4a717d91"}[chunkId] + ".css";
};